"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/system/Box"));
var general_1 = require("utils/general");
var BarHor_1 = require("./BarHor");
exports.default = (0, styles_1.styled)(Box_1.default, { shouldForwardProp: (0, general_1.omitProps)('color') })(function (_a) {
    var theme = _a.theme, _b = _a.color, color = _b === void 0 ? 'neutral' : _b;
    return ({
        backgroundColor: (0, BarHor_1.getColor)(theme, color),
        height: theme.spacing(2),
        width: theme.spacing(2),
        borderRadius: 4,
        marginRight: theme.spacing(1),
    });
});
